import { Contract, type ContractRunner } from "ethers";
import { FactoryAbi } from "../abis";

export class FactoryService {
  contract(factoryAddress: string, runner: ContractRunner) {
    return new Contract(factoryAddress, FactoryAbi, runner) as any;
  }

  async deployVault(
    factoryAddress: string,
    owner: string,
    salt: string,
    runner: ContractRunner,
    overrides: Record<string, unknown> = {},
  ) {
    return this.contract(factoryAddress, runner).deployVault(owner, salt, overrides);
  }

  async computeVaultAddress(
    factoryAddress: string,
    owner: string,
    salt: string,
    runner: ContractRunner,
  ): Promise<string> {
    return this.contract(factoryAddress, runner).computeVaultAddress(owner, salt);
  }

  async getOwnerVaults(
    factoryAddress: string,
    owner: string,
    runner: ContractRunner,
  ): Promise<string[]> {
    return this.contract(factoryAddress, runner).getOwnerVaults(owner);
  }

  async getOwnerVaultCount(
    factoryAddress: string,
    owner: string,
    runner: ContractRunner,
  ): Promise<number> {
    return Number(await this.contract(factoryAddress, runner).getOwnerVaultCount(owner));
  }

  async isVaultFromFactory(
    factoryAddress: string,
    vaultAddress: string,
    runner: ContractRunner,
  ): Promise<boolean> {
    return this.contract(factoryAddress, runner).isVaultFromFactory(vaultAddress);
  }
}
